'use client';
import './style.scss';
import { useMatchData } from '@/hooks/useMatchData';
import NetSound from '../NetSound';

const MatchMinute = ({ matchId, className }) => {
  const { matchLive } = useMatchData(matchId);

  const STATUS = {
    NOT_STARTED: 0,
    FIRST_HALF: 1,
    HALF_TIME_BREAK: 2,
    SECOND_HALF: 3,
    EXTRA_TIME: 4,
    PENALTY: 5,
    FINISHED: -1,
    CANCELLED: 7,
    TBD: 8,
    TERMINATED: 9,
    INTERRUPTED: 10,
    POSTPONED: 11,
  };

  const timeStart = matchLive?.halfStartTime || matchLive?.matchTime;
  const currentTime = Math.floor(Date.now() / 1000); // Current time in seconds
  let currentMinute = 0;
  let showMatchTime = false;
  const currentStatus = Number(matchLive?.status);

  let matchStatus = '--';
  // Calculate match minute based on the current status  
  if (timeStart && currentStatus) {
    
    switch (currentStatus) {
      case STATUS.FIRST_HALF:
        showMatchTime = true;
        currentMinute = Math.floor((currentTime - timeStart) / 60);
        if (currentMinute >= 45) {
          currentMinute = `45+${currentMinute - 45}`; // Show 45+X for first half additional time
        }
        break;

      case STATUS.SECOND_HALF:
        showMatchTime = true;
        currentMinute = 45 + Math.floor((currentTime - timeStart) / 60);
        if (currentMinute >= 90) {
          currentMinute = `90+${currentMinute - 90}`; // Show 90+X for second half additional time
        }
        break;

      case STATUS.EXTRA_TIME:
        showMatchTime = true;
        currentMinute = 90 + Math.floor((currentTime - timeStart) / 60); // Extra time starts after 90 minutes
        break;
      
      case STATUS.HALF_TIME_BREAK:
        matchStatus = 'HT';
        break;

      case STATUS.NOT_STARTED:
        matchStatus = 'NS';
        break;

      case STATUS.FINISHED:
        matchStatus = 'FT';
        break;

      default:
        showMatchTime = false; // Don't show match time for other statuses
        break;
    }
  }
    
  return (
    <div className={className}>
      {showMatchTime ? (
        <span className='whitespace-nowrap'>
          {currentMinute} <span className="blink">'</span>
          <NetSound data={matchLive.homeScore}/>
          <NetSound data={matchLive.awayScore}/>
        </span>
      ) : (
        matchStatus
      )}
    </div>
  );
};

export default MatchMinute;



